var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hidden)?_c('el-tooltip',{attrs:{"content":_vm.desc,"effect":"light","open-delay":300,"placement":"top"}},[(!_vm.small)?_c('span',{staticClass:"badge-danger badge mx-1 custom",class:{
                'badge-danger': _vm.percent<0, 
                'badge-success': _vm.percent>=0, 
                'super': _vm.percentdiff > 0 }},[_vm._v("\n            "+_vm._s(this.period)+"\n            "),(_vm.percentdiff > 0)?_c('i',[_vm._v("🚀")]):_vm._e()]):_vm._e(),(_vm.small)?_c('span',{staticClass:"smalldot",class:{
                'danger': _vm.percent<0, 
                'success': _vm.percent>=0, 
                'super': _vm.percentdiff > 0 }}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }